import { getRegion }  from '@/utils/common'
export const formatCurrency = (amount: number | string): string => {
  const value = typeof amount === 'string' ? Number(amount) : amount
  const priceFormatter = new Intl.NumberFormat(getRegion()?.locale, {
    style: 'currency',
    currency: getRegion()?.currency
  })

  return Number.isNaN(value) ? '' : priceFormatter.format(value)
}
